<template>
  <div class="ap-buyer-index">
    <div class="clearfix acc-info" style="overflow: hidden">
      <div class="float-left account" style="height: 72px" @click="$router.push('/buyer/accountSet')">
        <img class="viewHead" v-if="userDetail.wechatNickname" :src="headImgUrl" />
        <img class="viewHead" v-else src="@/assets/icons/user.png" />
        <div style="float: left; margin-left: 10px">
          <div>
            <strong>{{ userDetail.name }}</strong>
          </div>
          <div>
            <strong>{{ userDetail.userPrincipals[0].principal }}</strong>
          </div>
        </div>
      </div>
      <div class="float-left corp">
        <strong style="font-family: '微软雅黑 Regular'">{{ userDetail.orgName }}</strong>
        <div class="font12" style="padding: 5px">
          <span>信用等级</span>
          <strong class="stars" style="color: #f03">A</strong>
          <span>(8.3)</span>
        </div>
      </div>
      <div class="pass">
        <img src="@/assets/icons/u73.svg" />
        已通过
      </div>
    </div>
    <div class="item message">
      <div class="title">
        <span>最近通知</span>
        <router-link to="/buyer/message">全部通知</router-link>
        <ul style="margin-top: 10px">
          <li class="clearfix" v-for="it in msgList" :key="it.id" :class="{ active: !it.read }">
            <div class="status"></div>
            <div class="float-left cont" @click="readMsg(it)">{{ it.content }}</div>
            <div class="float-right time">{{ it.sendTime | toShortDateTime }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item">
      <div class="title">订单速览</div>
      <div class="clearfix">
        <table class="table table-bordered float-left">
          <tr>
            <td>待确认</td>
            <td>待发货</td>
            <td>待结款</td>
            <td>已完成</td>
          </tr>
          <tr>
            <td class="number">
              <a>
                <span v-if="orderCount.countUnConfirmOrders">{{ orderCount.countUnConfirmOrders.qty }}</span>
                <span v-else>-</span>
              </a>
            </td>
            <td class="number">
              <a>
                <span v-if="orderCount.countUnShippedOrders">{{ orderCount.countUnShippedOrders.qty }}</span>
                <span v-else>-</span>
              </a>
            </td>
            <td class="number">
              <a>
                <span v-if="orderCount.countUnPaidOrders">{{ orderCount.countUnPaidOrders.qty }}</span>
                <span v-else>-</span>
              </a>
            </td>
            <td class="number">
              <a>
                <span v-if="orderCount.countFinishedOrders">{{ orderCount.countFinishedOrders.qty }}</span>
                <span v-else>-</span>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      userDetail: {
        userPrincipals: [{}],
      },
      msgList: [],
      orderCount: {},
    };
  },
  computed: {
    ...mapState(["headImgUrl"]),
  },
  created() {
    this.getUserDetail();
    this.getMsgList();
    this.getOrderCount();
  },
  methods: {
    getUserDetail() {
      this.$get("/spms/myProfiles/getProfile", {}, { noFailureMsg: true })
        .then((res) => (this.userDetail = res))
        .catch((err) => {});
    },
    getMsgList() {
      this.$post("/shared/notification/query", { offset: 0, limit: 5, criteria: { type: "M2B" } })
        .then((res) => (this.msgList = res.results))
        .catch((err) => {});
    },
    readMsg(it) {
      if (!it.read) {
        this.$get("/shared/notification/read/" + it.id)
          .then(() => {
            this.$root.eventBus.$emit("refreshMsgCount");
            this.getMsgList();
          })
          .catch((err) => {});
      }
      if (it.type == "ORDER") {
        window.open("#/buyer/order/" + it.refId, "_blank");
      }
    },
    getOrderCount() {
      this.$post("/opms/order/mall/statistics/")
        .then((res) => (this.orderCount = res))
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.viewHead {
  width: 44px;
  height: 44px;
  float: left;
  border-radius: 50%;
}
</style>